import Image from 'components/common/Image';
import { endOfYear } from 'date-fns';
import { Box, Calendar, Markdown, Text } from 'grommet';
import usePageTitle from 'hooks/usePageTitle';
import useResponsive from 'hooks/useResponsive';
import EditAssetButton from 'modules/admin/components/EditAssetButton';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'rxbeach/react';
import { map } from 'rxjs';
import { Course } from 'types';
import { course$ } from './course$';

const viewModel$ = course$.pipe(
  map(({ byId }) => ({
    byShortid: Object.fromEntries(Object.values(byId).map(item => [item.shortid, item]))
  }))
)

const SingleCourse = ({ byShortid }: { byShortid: Record<string, Course> }) => {
  const { isMobile } = useResponsive();
  const [showAll, setShowAll] = useState(false)
  const param = useParams<{ shortid: string }>();
  const course = byShortid?.[`${param?.shortid}`];
  usePageTitle(course?.label);

  const [dates, setDates] = useState<string[]>([]);

  useEffect(() => {
    setDates(course?.dates?.map(e => new Date(e).toISOString()) || [])
  }, [course])
  if (!course) return null;

  const overflow = course.markdown.length > 200;
  const text = (showAll || !overflow) ? course.markdown : `${course.markdown.substring(0, 200)}...`;

  return (
    <Box
      as="article"
      justify="center"
      align="center"
      direction="column"
      fill="horizontal"
    >
      {course.image && (
        <Box
          height="medium"
          width={{ max: 'large' }}
          fill="horizontal"
          margin="small"
        >
          <Image src={course.image} style={{ borderRadius: '10px' }} />
        </Box>
      )}
      <Box width={{ max: 'large' }} fill="horizontal" pad={{ horizontal: 'medium' }} margin="small" style={{ wordBreak: 'break-word' }}>
        <Text size="xlarge" weight="bold"> {course.label} </Text>
        <Markdown>{text}</Markdown>
        {!showAll && (<Text onClick={() => setShowAll(true)} style={{ color: '#367de8', cursor: 'pointer' }}>Les Mer</Text>)}
        <EditAssetButton shortid={course.shortid} label="Endre kurs" type="kurs" />
      </Box>
      <Box width={{ max: 'large' }} fill="horizontal" pad={{ horizontal: 'medium' }} margin="small" style={{ borderTop: '1px solid #f0f0f0' }}>
        <Text size="medium" weight="bold"> Sted: {course.location} </Text>
        <Text size="medium" weight="bold"> Kontakt: {course.contact} </Text>
        <Text size="medium" weight="bold"> Pris: {course.price} </Text>
      </Box>
      {dates.length !== 0 && (
        <Box width={{ max: 'large' }} fill="horizontal" pad={{ horizontal: 'medium' }} margin="small" style={{ borderTop: '1px solid #f0f0f0' }} overflow={{ horizontal: 'auto' }}>
          <Calendar
            dates={dates}
            daysOfWeek
            firstDayOfWeek={1}
            animate={false}
            size={isMobile ? 'small' : 'medium'}
            bounds={[new Date().toISOString(), endOfYear(new Date()).toISOString()]}
            onSelect={() => setDates(course.dates.map(e => new Date(e).toISOString()))}
          />
        </Box>
      )}
    </Box>
  );
};

export default connect(SingleCourse, viewModel$);

